import { ButtonSkeleton } from '../Button';
import { Description } from '../Description';
import { Group } from '../Group';
import { Heading } from '../Heading';
import { TextSkeleton } from '../Skeleton';
import { ActionableContainer } from './ActionableContainer';

/**
 * A Skeleton for ActionableContainer including a heading, description on the left
 * and a button on the right, like in our settings panels.
 */
export function ActionableContainerSkeleton(props: {
    heading?: string;
    description?: string;
    buttonLabel?: string;
}) {
    const {
        heading = 'Heading loading...',
        description = 'A long description that is loading...',
        buttonLabel = 'Button loading...',
    } = props;

    return (
        <ActionableContainer orientation="horizontal">
            <Group>
                <Heading>
                    <TextSkeleton>{heading}</TextSkeleton>
                </Heading>
                <Description>
                    <TextSkeleton>{description}</TextSkeleton>
                </Description>
            </Group>
            <ButtonSkeleton label={buttonLabel} />
        </ActionableContainer>
    );
}
